import type { ReportSettingsType } from '@/util/types/serverTypeCollection/reportSettings';

export type PropairExperience = 'legacy' | 'v1' | 'v2';

export type ResolvedRepairQuoteExperience = {
  propairExperience: PropairExperience;
  qwikFixEnabled: boolean;
  isOverviewMode: boolean;
};

export function inferPropairExperience(
  settings?: Partial<ReportSettingsType> | null,
): PropairExperience {
  if (!settings) return 'v1';
  if (settings.propairExperience) return settings.propairExperience;
  if (settings.proPairExperience !== false) return 'v1';
  return 'legacy';
}

export function resolveRepairQuoteExperience(
  settings?: Partial<ReportSettingsType> | null,
  options?: { hasQwikFixIntegration?: boolean },
): ResolvedRepairQuoteExperience {
  const propairExperience = inferPropairExperience(settings);
  const hasIntegration = options?.hasQwikFixIntegration ?? true;
  const qwikFixEnabled =
    hasIntegration &&
    propairExperience !== 'v1' &&
    settings?.qwikFixExperience === true;

  return {
    propairExperience,
    qwikFixEnabled,
    isOverviewMode: propairExperience === 'v2',
  };
}

export const PROPAIR_EXPERIENCE_OPTIONS: {
  value: PropairExperience;
  label: string;
  description: string;
}[] = [
  {
    value: 'legacy',
    label: 'Contractor Match (Legacy)',
    description: 'Match repair items to contractors configured in settings.',
  },
  {
    value: 'v1',
    label: 'ProPair v1',
    description: 'Category-based repair quotes via Thumbtack categorization flow.',
  },
  {
    value: 'v2',
    label: 'ProPair v2 — Repair List Landing Page',
    description: 'Post-inspection repair list hub with quote partner chooser.',
  },
];
